import { MAP_TYPES } from '@deck.gl/carto';

const MIRAMARLIFTSTATIONS_SOURCE_ID = 'miramarLiftStationsSource';

const source = {
  id: MIRAMARLIFTSTATIONS_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Miramar_Lift_Stations`,
};

export default source;
